import { useCreation } from '@umijs/hooks';
import { COUNTS, MONITORING } from 'api';
import get from 'lodash/get';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useFetch from 'utils/fetch/useFetch';
import { setCount } from '../../store/reducers/chatSlice';
import Menu from './Menu';

function Wrapper() {
  const dispatch = useDispatch();
  const idTiket = useSelector((state) => get(state, `chat.idTiket`, null));
  const countMess = useSelector((state) => get(state, `chat.count`, null));
  const { data: counts } = useFetch(COUNTS, {
    uniqId: 'counts',
    autoFetch: true,
  });

  const webSocket = useCreation(() => {
    const token = localStorage.getItem('access_token');
    return new WebSocket(`${MONITORING}?authorization=OAuth%20${token}`);
  });

  useEffect(() => {
    if (webSocket) {
      webSocket.onopen = () => {
        console.log('ws open');
      };
      webSocket.onclose = () => {
        console.log('ws closed');
      };
    }
  }, [webSocket, window.location.href]);

  useEffect(() => {
    if (idTiket) {
      webSocket.onmessage = function (event) {
        const responce = JSON.parse(event.data);
        if (
          responce.type === 'new_message' &&
          responce.data.ticket_id !== idTiket
        ) {
          dispatch(setCount(countMess + 1));
        }
      };
    } else {
      webSocket.onmessage = function (event) {
        const responce = JSON.parse(event.data);
        if (responce.type === 'new_message') {
          dispatch(setCount(countMess + 1));
        }
      };
    }
  }, [webSocket, idTiket, window.location.href, countMess]);

  useEffect(() => {
    {
      if (counts) {
        dispatch(setCount(counts.messages));
      }
    }
  }, [counts]);
  return (
    <div>
      <Menu counts={counts} message={countMess !== 0 ? countMess : null} />
    </div>
  );
}

Wrapper.propTypes = {};

export default Wrapper;
